import { Vue, Component, Prop, Watch } from "@wagich/vue-facing-decorator-metadata";
import { CustomForm } from "../custom-form/custom-form";

import { render } from "./cta-form-trigger.html";
import { BModalComponent } from "buefy/types/components";

@Component({
	render,
	components: {
		CustomForm,
	}
})
export class CtaFormTrigger extends Vue {
	private modal: BModalComponent;

	@Prop({ required: true })
	formId: string;

	@Prop()
	type: string;

	@Prop()
	value: string;

	@Prop({ type: [String, Object] })
	metadata: string | object;

	open() {
		let decodedMetadata = {};
		if (typeof (this.metadata) === "string") {
			decodedMetadata = JSON.parse(this.metadata);
		} else {
			decodedMetadata = this.metadata;
		}

		this.modal = this.$buefy.modal.open({
			component: CustomForm,
			props: {
				formId: this.formId,
				metadata: decodedMetadata
			},
			events: {
				close: this.close
			}
		});
		document.documentElement.dispatchEvent(new CustomEvent("modal-opened"));
		document.documentElement.addEventListener("modal-opened", e => {
			this.modal.close();
		}, { once: true });
	}

	close() {
		this.modal.close();
	}
}
